module.exports = __webpack_public_path__ + "static/media/04.68343ee4.jpg";